"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAVIGATION_WIDTH = exports.NAVIGATION_DEFAULT_ENABLED = exports.SIDEBAR_DEFAULT_ENABLED = exports.SERVICE_NAVIGATION_WIDTH = exports.PAGE_HEADER_HEIGHT = exports.ARGUS_MENU_HEIGHT = void 0;
/* The height of the ARGUS menu component in pixels  */
exports.ARGUS_MENU_HEIGHT = 64;
exports.PAGE_HEADER_HEIGHT = 64;
exports.SERVICE_NAVIGATION_WIDTH = 64;
exports.SIDEBAR_DEFAULT_ENABLED = true;
exports.NAVIGATION_DEFAULT_ENABLED = false;
exports.NAVIGATION_WIDTH = 300;
